<script>
  import { routeSlugs } from "@/utils/routes-translations";
  import { capitalize } from "@/utils/utils";
  import BreadCrumbs from "@/components/BreadCrumbs";
  import FlexibleContent from "@/components/FlexibleContent";
  import UsabillaContainer from "@/components/UsabillaContainer";

  export default {
    components: {
      BreadCrumbs,
      FlexibleContent,
      UsabillaContainer,
    },
    props: {
      page: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      showUsabillaWidget () {
        return (
          this.page &&
          this.page.sys &&
          this.page.sys.contentType.sys.id === "article"
        );
      },
      breadcrumbs () {
        const contentType = this.page.sys.contentType.sys.id;
        const crumbs = [];
        let prefix = "/";
        if (contentType === "page") {
          const parentPage = this.page.fields.parentPage;
          const grandParentPage =
            parentPage && parentPage.fields.parentPage
              ? parentPage.fields.parentPage
              : false;
          if (grandParentPage) {
            crumbs.push({
              title: grandParentPage.fields.title,
              slug: prefix + grandParentPage.fields.slug,
            });
            prefix += grandParentPage.fields.slug + "/";
          }
          if (parentPage) {
            crumbs.push({
              title: parentPage.fields.title,
              slug: prefix + parentPage.fields.slug,
            });
            prefix += parentPage.fields.slug + "/";
          }
          crumbs.push({
            title: this.page.fields.title,
            slug: prefix + this.page.fields.slug,
          });
        }
        if (contentType === "article") {
          const articlesName = routeSlugs.articles.slice(1);
          prefix += articlesName;
          crumbs.push({
            title: capitalize(articlesName),
            slug: prefix,
          });
          prefix += "/categorie/";
          crumbs.push({
            title: this.page.fields.category.fields.title,
            slug: prefix + this.page.fields.category.fields.slug,
          });
          crumbs.push({
            title: this.page.fields.title,
            slug: "/artikel/" + this.page.fields.slug,
          });
        }
        return crumbs;
      },
    },
    mounted () {
      if (this.showUsabillaWidget) {
        document.body.classList.add("show-usabilla-button");
      }
    },
    beforeDestroy () {
      document.body.classList.remove("show-usabilla-button");
    },
  };
</script>

<template>
  <article class="view view-page">
    <bread-crumbs :breadcrumbs="breadcrumbs" />
    <header class="view-header">
      <div class="md:px-8 container px-4">
        <div class="md:w-10/12 xl:w-6/12 md:text-center w-full mx-auto">
          <animated-title>
            <h1 class="animate md:text-5xl pb-4 text-3xl">
              {{ page.fields.title }}
            </h1>
          </animated-title>
          <rich-text-content
            :content="page.fields.introduction"
            class="mb-10 text-lg"
          />
        </div>
      </div>
    </header>
    <flexible-content :content="page.fields.content" />
    <div class="usabilla-container container">
      <div class="md:w-8/12 lg:w-6/12 w-full mx-auto">
        <usabilla-container
          v-if="showUsabillaWidget"
          ub-id="5f91a17ecd85036ec93ce2de"
          class="mt-6"
        />
      </div>
    </div>
  </article>
</template>

<style lang="scss">
.view-page {
  .usabilla-container {
    @apply mt-0;
  }
}
</style>
